import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { HttpClientModule } from '@angular/common/http';

import { I18nModule } from '../i18n/i18n.module';
import { SharedModule } from '../common/shared.module';
import { ReportsRoutingModule } from './reports-routing.module';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatMenuModule } from '@angular/material/menu';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import {MatTabsModule} from '@angular/material/tabs';

import { ReportsComponent } from './components/reports/reports.component';
import { ReportsMapViewComponent } from './components/reports-map-view/reports-map-view.component';
import { ReportDataComponent } from './components/report-data/report-data.component';
import { ReportGridComponent } from './components/report-grid/report-grid.component';
import { ReportLayoutComponent } from './components/report-layout/report-layout.component';
import { ReportBreadcumComponent } from './components/report-breadcum/report-breadcum.component';
import { ReportQueryComponent } from './components/report-query/report-query.component';
import { ReportFilterComponent } from './components/report-filter/report-filter.component';
import { ReportMapLegendComponent } from './components/report-map-legend/report-map-legend.component';
import { ReportsCategoryComponent } from './components/reports-category/reports-category.component';
import { ReportUnitComponent } from './components/reports-lists/components/report-unit/report-unit.component';
import { ReportInventoryComponent } from './components/reports-lists/components/report-inventory/report-inventory.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { ReportsPreviewModule } from './components/reports-preview/reports-preview.module';
import { RecentSavedReportComponent } from './components/recent-saved-report/recent-saved-report.component';
import { ReportOccupancyLeaseComponent } from './components/reports-lists/components/report-occupancy-lease/report-occupancy-lease.component';
import { ReportPopulationComponent } from './components/reports-lists/components/report-population/report-population.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SaveReportDailogComponent } from './components/save-report-dailog/save-report-dailog.component';
import { ReportUnderConstructionComponent } from './components/reports-lists/components/report-under-construction/report-under-construction.component';
import { ReportPropertyProfilingComponent } from './components/reports-lists/components/report-property-profiling/report-property-profiling.component';
import { ReportMallProfilingComponent } from './components/reports-lists/components/report-mall-profiling/report-mall-profiling.component';
import { ReportMallInventoryComponent } from './components/reports-lists/components/report-mall-inventory/report-mall-inventory.component';
import { ReportFbComponent } from './components/reports-lists/components/report-fb/report-fb.component';
import { ReportTenantProfilingComponent } from './components/reports-lists/components/report-tenant-profiling/report-tenant-profiling.component';
import { MinMaxSliderComponent } from './components/filter-components/min-max-slider/min-max-slider.component';
import { MultiSelectComponent } from './components/filter-components/multi-select/multi-select.component';
import { MatChipsModule } from '@angular/material/chips';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSelectModule } from '@angular/material/select';
import { MatSliderModule } from '@angular/material/slider';
import { FormTextComponent } from './components/filter-components/form-text/form-text.component';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ReportTransactionsComponent } from './components/reports-lists/components/report-transactions/report-transactions.component';
import { DateRangeComponent } from './components/filter-components/date-range/date-range.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { ReportHouseVillasComponent } from './components/reports-lists/components/report-house-villas/report-house-villas.component';
import { MAT_DATE_LOCALE, MatNativeDateModule } from '@angular/material/core';
import { ReportsContainerComponent } from './components/reports-lists/components/reports-container/reports-container.component';
import { MapPropertyDetailsComponent } from './components/reports-map-view/map-property-details/map-property-details.component';
import { ReportHouseRentalComponent } from './components/reports-lists/components/report-house-rental/report-house-rental.component';
import { ReportHouseLandVacancyComponent } from './components/reports-lists/components/report-house-land-vacancy/report-house-land-vacancy.component';
import { ReportFilterGroupComponent } from './components/report-filter-group/report-filter-group.component';
import { ReportOfficeSpaceRentalComponent } from './components/reports-lists/components/report-office-space-rental/report-office-space-rental.component';
import { ReportNeighDetailsComponent } from './components/reports-map-view/report-neigh-area-details/report-neigh-area-details.component';
import { ReportWarehouseRentalComponent } from './components/reports-lists/components/report-warehouse-rental/report-warehouse-rental.component';
import { OverviewCardComponent } from './components/reports-lists/components/common/overview-card/overview-card.component';
import { ReportInvestmentInventoryComponent } from './components/reports-lists/components/report-investment-inventory/report-investment-inventory.component';
import { ReportProjectDetailsComponent } from './components/reports-map-view/report-project-details/report-project-details.component';
import { ReportOccupancyRentalComponent } from './components/reports-lists/components/report-occupancy-rental/report-occupancy-rental.component';
import { ReportCommonInfoModule } from './components/reports-lists/components/common/report-common-info.module';
import { ReportRetailInventoryComponent } from './components/reports-lists/components/report-retail-inventory/report-retail-inventory.component';
import { ReportOfficeInventoryComponent } from './components/reports-lists/components/report-office-inventory/report-office-inventory.component';
import { ReportWarehouseInventoryComponent } from './components/reports-lists/components/report-warehouse-inventory/report-warehouse-inventory.component';
import { ReportsTenantsMapViewComponent } from './components/reports-tenants-map-view/reports-tenants-map-view.component';
import { LoadCatchmentComponent } from './components/reports-map-view/load-catchment/load-catchment.component';
import { DrawCatchmentComponent } from './components/reports-map-view/draw-catchment/draw-catchment.component';
import { CatchmentModelComponent } from './components/reports-map-view/draw-catchment/catchment-model/catchment-model.component';

import { MatProgressBarModule } from '@angular/material/progress-bar';
import { ReportPbiRetailMallsPlazaComponent } from './components/reports-lists/components/power-bi/report-pbi-retail-malls-plaza/report-pbi-retail-malls-plaza.component';
import { ReportPbiRiyadhStorageSectorComponent } from './components/reports-lists/components/power-bi/report-pbi-riyadh-storage-sector/report-pbi-riyadh-storage-sector.component';
import { AmentiesFilterFormComponent } from './components/filter-components/amenties-filter-form/amenties-filter-form.component';
import { PowerBiDynamicComponent } from './components/reports-lists/components/power-bi/power-bi-dynamic/power-bi-dynamic.component';
import { PbiVisualContainerComponent } from './components/reports-lists/components/power-bi/power-bi-dynamic/pbi-visual-container/pbi-visual-container.component';
import { PowerBiPropertyDetailsComponent } from './components/reports-lists/components/power-bi/power-bi-property-details/power-bi-property-details.component';
import { LandInventoryComponent } from './components/reports-lists/components/land-inventory/land-inventory.component';
import { ReportPowerBiFullWithMapComponent } from './components/reports-lists/components/power-bi/report-power-bi-full-with-map/report-power-bi-full-with-map.component';
import { ReportPowerBiFullWithoutMapComponent } from './components/reports-lists/components/power-bi/report-power-bi-full-without-map/report-power-bi-full-without-map.component';
import { ReportOccupancyRentalBasicComponent } from './components/reports-lists/components/report-occupancy-rental-basic/report-occupancy-rental-basic.component';
import { ReportOfficeSpaceRentalBasicComponent } from './components/reports-lists/components/report-office-space-rental-basic/report-office-space-rental-basic.component';
import { ReportTransactionsBasicComponent } from './components/reports-lists/components/report-transactions-basic/report-transactions-basic.component';
import { RoadAccessFilterFormComponent } from './components/filter-components/road-access-filter-form/road-access-filter-form.component';
import { SearchedAddressComponent } from './components/reports-map-view/searched-address/searched-address.component';
import { MapLayersComponent } from './components/reports-map-view/map-layers/map-layers.component';
import { ReportWarehouseRentalV2Component } from './components/reports-lists/components/report-warehouse-rental-v2/report-warehouse-rental-v2.component';
import { ReportRetailRentalComponentV2 } from './components/reports-lists/components/report-retail-rental-v2/report-retail-rental-v2.component';
import { PieChartReportComponent } from './components/reports-lists/components/charts/pie-chart-report/pie-chart-report.component';
import { ReportOfficeRentalV2Component } from './components/reports-lists/components/report-office-rental-v2/report-office-rental-v2.component';
import { UniversalSearchComponent } from './components/reports-map-view/universal-search/universal-search.component';
import { ProjectDetailOverviewComponent } from './components/reports-map-view/report-project-details/project-detail-overview/project-detail-overview.component';
import { ReportRetailInventoryV1Component } from './components/reports-lists/components/report-retail-inventory-v1/report-retail-inventory-v1.component';
import { ReportOfficeInventoryV1Component } from './components/reports-lists/components/report-office-inventory-v1/report-office-inventory-v1.component';
import { MatRadioModule } from '@angular/material/radio';
import { TtmDateRangeComponent } from './components/filter-components/ttm-date-range/ttm-date-range.component';
import { ReportOccupancyRentalV2Component } from './components/reports-lists/components/report-occupancy-rental-v2/report-occupancy-rental-v2.component';
import { DownloadPropertyReportComponent } from './components/download-property-report/download-property-report.component';
import { ReportResidentialPrimeComponent } from './components/reports-lists/components/report-residential-prime/report-residential-prime.component';
import { MatSortModule } from '@angular/material/sort';
import { MatPaginatorModule } from '@angular/material/paginator';
import { PropertyLandParcelComponent } from './components/reports-map-view/report-project-details/property-land-parcel/property-land-parcel.component';
import { ReportWarehouseInventoryV2Component } from './components/reports-lists/components/report-warehouse-inventory-v2/report-warehouse-inventory-v2.component';
import { ReportsProjectRentalDataComponent } from './components/reports-map-view/report-project-details/reports-project-rental-data/reports-project-rental-data.component';
import { ProjectLandPricesComponent } from './components/reports-map-view/report-project-details/project-land-prices/project-land-prices.component';
import { LandPriceAnalysisComponent } from './components/reports-map-view/report-project-details/land-price-analysis/land-price-analysis.component';
import { CommonPropertyDetailPageComponent } from './components/reports-lists/components/common-property-detail-page/common-property-detail-page.component';
import { PropertyLandPriceDetailsTableComponent } from './components/reports-lists/components/common-property-detail-page/property-land-price-details-table/property-land-price-details-table.component';
import { PropertyPriceDetailsTableComponent } from './components/reports-lists/components/common-property-detail-page/property-price-details-table/property-price-details-table.component';
import { PropertyUnitPriceDetailsTableComponent } from './components/reports-lists/components/common-property-detail-page/property-unit-price-details-table/property-unit-price-details-table.component';
import { ResidentialRentalDetailsTableComponent } from './components/reports-lists/components/common-property-detail-page/residential-rental-details-table/residential-rental-details-table.component';
import { OfficeRentalDetailsTableComponent } from './components/reports-lists/components/common-property-detail-page/office-rental-details-table/office-rental-details-table.component';
import { RetailRentalDetailsTableComponent } from './components/reports-lists/components/common-property-detail-page/retail-rental-details-table/retail-rental-details-table.component';
import { WarehouseRentalDetailsTableComponent } from './components/reports-lists/components/common-property-detail-page/warehouse-rental-details-table/warehouse-rental-details-table.component';
import { LandPriceAnalysisChartComponent } from './components/reports-lists/components/common-property-detail-page/land-price-analysis-chart/land-price-analysis-chart.component';
import { LandPriceComparableChartComponent } from './components/reports-lists/components/common-property-detail-page/land-price-comparable-chart/land-price-comparable-chart.component';
import { VillaPriceAnalysisChartComponent } from './components/reports-lists/components/common-property-detail-page/villa-price-analysis-chart/villa-price-analysis-chart.component';
import { PriceAnalysisPropertyComponent } from './components/reports-lists/components/common-property-detail-page/price-analysis-property/price-analysis-property.component';
import { PropertyDetailLandParcelsComponent } from './components/reports-lists/components/common-property-detail-page/property-detail-land-parcels/property-detail-land-parcels.component';
import { PocReportComponent } from './components/reports-lists/components/poc-report/poc-report.component';
import { CdkDrag, CdkDragPlaceholder, CdkDropList } from '@angular/cdk/drag-drop';
import { TotalLandPropertyComponent } from './components/reports-lists/components/component-standalone/total-land-property/total-land-property.component';
import { AverageLandAreaComponent } from './components/reports-lists/components/component-standalone/average-land-area/average-land-area.component';
import { LandDevelopmentRateComponent } from './components/reports-lists/components/component-standalone/land-development-rate/land-development-rate.component';
import { ResidentialLandSupply5YearsComponent } from './components/reports-lists/components/component-standalone/residential-land-supply5-years/residential-land-supply5-years.component';
import { IndependentPropertiesComponent } from './components/reports-lists/components/component-standalone/independent-properties/independent-properties.component';
import { HouseVillaProjectsComponent } from './components/reports-lists/components/component-standalone/house-villa-projects/house-villa-projects.component';
import { GovernmentalPropertiesComponent } from './components/reports-lists/components/component-standalone/governmental-properties/governmental-properties.component';
import { MunicipalRegulationsComponent } from './components/municipal-regulations/municipal-regulations.component';
import { PowerBiMultiplePagesComponent } from './components/reports-lists/components/power-bi/power-bi-multiple-pages/power-bi-mutilple-pages.component';
import { ReportNavigationMenuComponent } from './components/report-navigation-menu/report-navigation-menu.component';
import { PowerBiMultiPageViewComponent } from './components/reports-lists/components/power-bi/power-bi-multi-pages-view/power-bi-multi-pages-view.component';
import { ResidentialUnitsComponent } from './components/reports-lists/components/common/report-property-detail/components/residential-units/residential-units.component';
import { ResidentialDetailTableComponent } from './components/reports-preview/components/reports-table/residential-detail-table/residential-detail-table.component';

@NgModule({
  declarations: [
    ReportsComponent,
    ReportsMapViewComponent,
    ReportDataComponent,
    ReportGridComponent,
    ReportLayoutComponent,
    ReportBreadcumComponent,
    ReportQueryComponent,
    ReportFilterComponent,
    ReportMapLegendComponent,
    ReportsCategoryComponent,
    ReportUnitComponent,
    ReportInventoryComponent,
    RecentSavedReportComponent,
    ReportOccupancyLeaseComponent,
    ReportPopulationComponent,
    SaveReportDailogComponent,
    ReportUnderConstructionComponent,
    ReportPropertyProfilingComponent,
    ReportMallProfilingComponent,
    ReportMallInventoryComponent,
    ReportFbComponent,
    ReportTenantProfilingComponent,
    MinMaxSliderComponent,
    MultiSelectComponent,
    FormTextComponent,
    ReportTransactionsComponent,
    DateRangeComponent,
    ReportHouseVillasComponent,
    ReportsContainerComponent,
    MapPropertyDetailsComponent,
    ReportHouseRentalComponent,
    ReportHouseLandVacancyComponent,
    ReportFilterGroupComponent,
    ReportOfficeSpaceRentalComponent,
    ReportNeighDetailsComponent,
    ReportWarehouseRentalComponent,
    OverviewCardComponent,
    ReportInvestmentInventoryComponent,
    ReportProjectDetailsComponent,
    ReportOccupancyRentalComponent,
    ReportOccupancyRentalV2Component,
    ReportRetailInventoryComponent,
    ReportRetailInventoryV1Component,
    ReportOfficeInventoryComponent,
    ReportOfficeInventoryV1Component,
    ReportWarehouseInventoryComponent,
    ReportsTenantsMapViewComponent,
    LoadCatchmentComponent,
    DrawCatchmentComponent,
    CatchmentModelComponent,
    ReportPbiRiyadhStorageSectorComponent,
    AmentiesFilterFormComponent,
    ReportPbiRetailMallsPlazaComponent,
    ReportPbiRiyadhStorageSectorComponent,
    PowerBiDynamicComponent,
    PbiVisualContainerComponent,
    PowerBiPropertyDetailsComponent,
    LandInventoryComponent,
    ReportPowerBiFullWithMapComponent,
    ReportPowerBiFullWithoutMapComponent,
    ReportOccupancyRentalBasicComponent,
    ReportOfficeSpaceRentalBasicComponent,
    ReportTransactionsBasicComponent,
    RoadAccessFilterFormComponent,
    SearchedAddressComponent,
    MapLayersComponent,
    ReportWarehouseRentalV2Component,
    ReportRetailRentalComponentV2,
    PieChartReportComponent,
    ReportOfficeRentalV2Component,
    MapLayersComponent,
    UniversalSearchComponent,
    ProjectDetailOverviewComponent,
    TtmDateRangeComponent,
    DownloadPropertyReportComponent,
    ReportResidentialPrimeComponent,
    PropertyLandParcelComponent,
    ReportWarehouseInventoryV2Component,
    ReportsProjectRentalDataComponent,
    ProjectLandPricesComponent,
    LandPriceAnalysisComponent,
    CommonPropertyDetailPageComponent,
    PropertyLandPriceDetailsTableComponent,
    PropertyPriceDetailsTableComponent,
    PropertyUnitPriceDetailsTableComponent,
    ResidentialRentalDetailsTableComponent,
    OfficeRentalDetailsTableComponent,
    RetailRentalDetailsTableComponent,
    WarehouseRentalDetailsTableComponent,
    LandPriceAnalysisChartComponent,
    LandPriceComparableChartComponent,
    VillaPriceAnalysisChartComponent,
    PriceAnalysisPropertyComponent,
    PropertyDetailLandParcelsComponent,
    PocReportComponent,
    TotalLandPropertyComponent,
    AverageLandAreaComponent,
    LandDevelopmentRateComponent,
    ResidentialLandSupply5YearsComponent,
    IndependentPropertiesComponent,
    HouseVillaProjectsComponent,
    GovernmentalPropertiesComponent,
    MunicipalRegulationsComponent,
    PowerBiMultiplePagesComponent,
    ReportNavigationMenuComponent,
    PowerBiMultiPageViewComponent,
    ResidentialUnitsComponent,
    ResidentialDetailTableComponent
  ],
  imports: [
    CommonModule,
    I18nModule,
    SharedModule,
    ReportsRoutingModule,
    MatIconModule,
    HttpClientModule,
    MatExpansionModule,
    MatMenuModule,
    FormsModule,
    ReactiveFormsModule,
    ReportsPreviewModule,
    MatTooltipModule,
    MatCheckboxModule,
    MatChipsModule,
    MatSelectModule,
    MatSliderModule,
    NgxMatSelectSearchModule,
    MatProgressSpinnerModule,
    MatDatepickerModule,
    MatNativeDateModule,
    ReportCommonInfoModule,
    MatProgressBarModule,
    MatSlideToggleModule,
    MatRadioModule,
    MatSortModule,
    MatPaginatorModule,
    CdkDropList,
    CdkDrag,
    CdkDragPlaceholder,
    MatTabsModule
  ],
  exports: [ReportsComponent,
    RecentSavedReportComponent,
    MinMaxSliderComponent,
    MultiSelectComponent,
    FormTextComponent,
    ReportMapLegendComponent,
    ReportsMapViewComponent,
    ReportNeighDetailsComponent,
    OverviewCardComponent,
    DownloadPropertyReportComponent,
    ResidentialDetailTableComponent
  ],
  providers: [{ provide: MAT_DATE_LOCALE, useValue: 'en-GB' }]
})

export class ReportsModule { }
